import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableMagicLinkTimedOut = loadable(
  () => import('./MagicLinkTimedOut'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadableMagicLinkTimedOut;
